import React, { memo, useMemo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { useInternalPermissions } from 'src/hooks/useInternalPermissions'
import { addS } from 'src/utils/baseUtils'
import { buildPermissionGroups } from 'src/utils/internalAccess/permissionSelection'
import { InternalPermissionGroup } from './InternalPermissionGroup'

interface Props {
  value: string[]
  /**
   * The role's permissions as loaded — drives the "Other" group, so an unknown permission stays
   * listed even after it is unticked.
   */
  rolePermissions: string[]
  disabled: boolean
  onChange(permissions: string[]): void
}

const InternalPermissionsFieldComponent = ({
  value,
  rolePermissions,
  disabled,
  onChange,
}: Props) => {
  const grantable = useInternalPermissions()

  const groups = useMemo(() => {
    return buildPermissionGroups(rolePermissions)
  }, [rolePermissions])

  return (
    <div css={tw`flex flex-col gap-3`} data-testid="internal-role-permissions-field">
      <Typography variant="body2" css={tw`text-xs text-shades-500`}>
        {value.length} {addS(value.length, 'permission')} selected
      </Typography>
      {groups.map((group) => {
        return (
          <InternalPermissionGroup
            key={group.label}
            group={group}
            selected={value}
            grantable={grantable}
            disabled={disabled}
            onChange={onChange}
          />
        )
      })}
    </div>
  )
}

export const InternalPermissionsField = memo(InternalPermissionsFieldComponent)
